export default __webpack_public_path__ + "static/media/card.30a8e976.png";